module.exports = __webpack_public_path__ + "img/eleccionesGenerales2022.069684fc.jpg";